/**
 * A best-list guide's in-depth product card. ClearBuy's `large` style maps to `nc-deals-large`
 * and its `best-list-large` style to `nc-deals-large-alt`; editors use either for the same
 * section, so every guide enrichment (pick extraction, the owner splice, DealHunt's fill)
 * treats them as one. Its own module because `bestCards` and `guidePicks` both need it and
 * `guidePicks` already imports `bestCards`.
 */
export function isInDepthDeal(block: { resource?: unknown }): boolean {
  return block.resource === 'nc-deals-large' || block.resource === 'nc-deals-large-alt'
}
